import axios from "axios";
import { apiCall, customAxios } from "./Interceptor";

const DOCUMENT_UPLOAD = "/document/upload";
const GET_DOC_BUSINESS_RULES = "/document/get/byBusinessRule/public";
const GET_DOC_BYE_LAWS = "/document/get/byLaws/public";
const GET_DOC_BY_ID = "/document/get";
const INTENT_SUBMIT = "banking/generateIntent";
const CAP_CON_GET_DOC = "consumer/capacity/get_document";
const CAP_GEN_GET_DOC = "generator/capacity/get_document";

const documentUpload = async (type, data, config) => {
  const response = await customAxios.post(
    `${DOCUMENT_UPLOAD}?type=${type}`,
    data ? data : null,
    config ? config : null
  );
  return response;
};

const getBusinessRulesUrl = async () => {
  const response = await customAxios.get(GET_DOC_BUSINESS_RULES);
  return response;
};

const getByeLawsUrl = async () => {
  const response = await customAxios.get(GET_DOC_BYE_LAWS);
  return response;
};

const getDocumentById = async (docId) => {
  const response = await customAxios.get(`${GET_DOC_BY_ID}?id=${docId}`);
  return response;
};

const templateIndentSubmit = async (data, config) => {
  const response = await customAxios.post(
    `${INTENT_SUBMIT}`,
    data ? data : null,
    config ? config : null
  );
  return response;
};

const consumerFixedTnC = async (data) => {
  const response = await customAxios.post(`${CAP_CON_GET_DOC}`, data);
  return response;
};

const fixedTnCGenerator = async (data) => {
  const response = await customAxios.post(`${CAP_GEN_GET_DOC}`, data);
  return response;
};

export const tcConsumerDocUpload = async (value, type, token) => {
  const selectedFile = value?.[0];
  if (!selectedFile) return;

  const form = new FormData();
  form.append("file", selectedFile);
  form.append("type", type);

  try {
    const response = await axios.post(
      "https://api-qa-tradeconnect.gna.energy/api/document/consumerUpload",
      form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response?.data?.code === 200) {
      return response.data.data.id;
    }
  } catch (error) {
    console.error("Upload failed", error);
  }
};
export const tcGeneratorUpload = async (value, type, token) => {
  const selectedFile = value?.[0];
  if (!selectedFile) return;

  const form = new FormData();
  form.append("file", selectedFile);
  form.append("type", type);

  try {
    const response = await axios.post(
      "https://api-qa-tradeconnect.gna.energy/api/document/generatorUpload/public",
      form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response?.data?.code === 200) {
      return response.data.data.id;
    }
  } catch (error) {
    console.error("Upload failed", error);
  }
};

export default {
  documentUpload,
  getBusinessRulesUrl,
  getByeLawsUrl,
  getDocumentById,
  templateIndentSubmit,
  consumerFixedTnC,
  fixedTnCGenerator,
};
